import type { ComponentMultiStyleConfig } from "@chakra-ui/react"

// dist/css/tabs.css — horizontal: 12px semibold uppercase, black 2px underline on the active tab;
// vertical (client files, admin): sentence case, black 2px rule on the left of the active tab.
export const Tabs: ComponentMultiStyleConfig = {
  parts: ["root", "tab", "tablist", "tabpanel"],
  variants: {
    line: ({ orientation }) =>
      orientation === "vertical"
        ? {
            tablist: {
              borderInlineStart: "none",
              borderRight: "1px solid",
              borderRightColor: "line",
              py: 2,
            },
            tab: {
              justifyContent: "flex-start",
              textAlign: "left",
              minH: "44px",
              py: "10px",
              pr: 4,
              pl: "18px",
              fontSize: "sm",
              fontWeight: "normal",
              letterSpacing: "normal",
              textTransform: "none",
              lineHeight: "snug",
              color: "textMuted",
              borderInlineStart: "2px solid",
              borderInlineStartColor: "transparent",
              marginInlineStart: 0,
              _hover: {
                color: "text",
                bg: "surfaceHover",
              },
              _selected: {
                color: "text",
                fontWeight: "semibold",
                bg: "transparent",
                borderInlineStartColor: "text",
              },
              _disabled: {
                color: "textSubtle",
                bg: "transparent",
              },
            },
            tabpanel: {
              pt: 2,
              pb: 0,
              pl: 12,
              pr: 0,
            },
          }
        : {
            // On a narrow screen the tabs scroll sideways instead of overflowing the page. The
            // grey line is an inset shadow, so the active underline still covers it inside the
            // scrolling list (a -1px margin would be clipped there).
            tablist: {
              gap: 8,
              overflowX: "auto",
              overflowY: "hidden",
              scrollbarWidth: "none",
              "&::-webkit-scrollbar": { display: "none" },
              boxShadow: "inset 0 -1px 0 var(--chakra-colors-line)",
              // Cancels Chakra's own line variant (2px inherited border), merged with this one.
              borderBottom: "none",
            },
            tab: {
              px: 0,
              pt: 3,
              pb: 4,
              fontSize: "2xs",
              fontWeight: "semibold",
              letterSpacing: "wider",
              textTransform: "uppercase",
              whiteSpace: "nowrap",
              color: "textSubtle",
              flexShrink: 0,
              borderBottom: "2px solid",
              borderBottomColor: "transparent",
              // Chakra's line variant pulls the tab 2px over a border this list no longer has.
              marginBottom: 0,
              _hover: {
                color: "text",
              },
              _selected: {
                color: "text",
                borderBottomColor: "text",
              },
              _disabled: {
                color: "textSubtle",
              },
            },
            tabpanel: {
              py: 6,
              px: 0,
            },
          },
  },
}
